import React, { useCallback, useMemo, useRef, useState } from "react";
import { ChatType } from "@common/constants/analytics-events";
import { trackChatClosed, trackChatOpened } from "@lib/analytics";
import { ChatContext, ChatDrawerPanel } from "./Chat.context";

export const ChatProvider: React.FC<{ children: React.ReactNode }> = ({
    children,
}) => {
    const [isOpen, setIsOpen] = useState<boolean>(false);
    const [panel, setPanel] = useState<ChatDrawerPanel>("chat");
    const [selectedThreadId, setSelectedThreadId] = useState<
        string | undefined
    >(undefined);

    const isOpenRef = useRef(false);
    const applyOpenState = useCallback((next: boolean) => {
        if (next === isOpenRef.current) {
            return;
        }
        isOpenRef.current = next;
        setIsOpen(next);
        if (next) {
            trackChatOpened({ chatType: ChatType.CLOSE_MANAGEMENT });
        } else {
            trackChatClosed({ chatType: ChatType.CLOSE_MANAGEMENT });
        }
    }, []);

    const open = useCallback(() => applyOpenState(true), [applyOpenState]);
    const close = useCallback(() => applyOpenState(false), [applyOpenState]);
    const toggle = useCallback(
        () => applyOpenState(!isOpenRef.current),
        [applyOpenState],
    );

    const value = useMemo(
        () => ({
            isOpen,
            open,
            close,
            toggle,
            panel,
            setPanel,
            selectedThreadId,
            setSelectedThreadId,
        }),
        [isOpen, open, close, toggle, panel, selectedThreadId],
    );

    return (
        <ChatContext.Provider value={value}>{children}</ChatContext.Provider>
    );
};
